import React from 'react';
import PageTitle from '../hooks/PageTitle';
import CareerApplicationForm from '../components/CareerApplicationForm';

const CareerApply = () => {
  return (
    <div className="min-h-screen pt-20 bg-gray-50">
      <PageTitle title="Career Application" />
      
      {/* Hero Section */}
      <section className="relative py-16 bg-gray-900 text-white">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="max-w-3xl mx-auto text-center">
            <h1 className="text-4xl md:text-5xl font-serif mb-4">
              Apply to Join Ashbourne Law
            </h1>
            <p className="text-xl text-gray-300">
              Take the next step in building your practice with us
            </p>
          </div>
        </div>
      </section>

      {/* Application Form Section */}
      <section className="py-16">
        <div className="max-w-3xl mx-auto px-4 sm:px-6 lg:px-8">
          <CareerApplicationForm />
        </div>
      </section>
    </div>
  );
};

export default CareerApply;
